import { ComponentProps, FC } from "react";
import moment from "moment";

import { Insights as InsightsUI } from "@ctra/components";
import { Epoch, TS } from "@ctra/utils";
import { InsightWorkflowState } from "@ctra/api";

import { useInsight, GenericInsightHeader } from "@insights";

import { GenericInsightBase } from "../../../processing/Base";

const {
  Dialog: { Header },
  TimePeriod
} = InsightsUI;

/**
 * Insight header
 * @param {{}} props
 * @returns {JSX.Element}
 * @constructor
 */
export const VulcanV2InsightHeader: FC<Partial<ComponentProps<typeof Header>>> = (props = {}) => {
  const {
    insight: { workflowStateLastModifiedDate, workflowState, startEpoch, endEpoch },
    getStateDescription
  } = useInsight<GenericInsightBase>();

  const diff = moment(Epoch.asMoment(startEpoch)).diff(moment(Epoch.asMoment(endEpoch)), "days");

  /**
   * Tell if we need to add a 3rd date to the time period
   * @type {boolean}
   */
  const hasTimePeriodExtra =
    workflowState !== InsightWorkflowState.toCheck && !!workflowStateLastModifiedDate;

  return (
    <GenericInsightHeader
      period={
        <TimePeriod
          withIcon={false}
          from={startEpoch}
          until={diff <= 1 ? void 0 : endEpoch}
          extra={
            hasTimePeriodExtra ? (
              <>
                {", "}
                {getStateDescription({
                  lastDate: TS.asMoment(workflowStateLastModifiedDate).format("LL")
                })}
              </>
            ) : null
          }
        />
      }
    />
  );
};
